/**
 * Legend component entry file8
 */


    require('./legend');

    require('./legend/ScrollableLegendModel');
    require('./legend/ScrollableLegendView');
    require('./legend/scrollableLegendAction');




//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/legendScroll.js
// module id = 877
// module chunks = 0